import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { Form, Row, Col, TimePicker, Flex, Button } from "antd";
import { useTranslation } from "react-i18next";

function DayField({ day, itemsInitialValues, form }: any) {
  const { t } = useTranslation();
  const checkOverlap = (currentRange: any, allRanges: any[]) => {
    const [currentStart, currentEnd] = currentRange;
    for (const range of allRanges) {
      const [start, end] = range;
      if (currentStart.isBefore(end) && start.isBefore(currentEnd)) {
        return true;
      }
    }
    return false;
  };
  return (
    <Form.List
      name={day}
      initialValue={itemsInitialValues ? itemsInitialValues[day] : [{}]}
    >
      {(fields, { add, remove }) =>
        fields.map(({ key, name, ...restField }, index) => (
          <Row
            key={key}
            style={{ marginBottom: 15 }}
            justify={"space-between"}
            align="middle"
            gutter={[10, 10]}
          >
            <Col span={18}>
              <Form.Item
                {...restField}
                name={[name, "timeRange"]}
                rules={[
                  {
                    required: true,
                    message: t("message.error.time_required"),
                  },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();
                      const allRanges = form
                        .getFieldValue(day)
                        .map((item: any, i: number) =>
                          i === index ? null : item?.timeRange
                        )
                        .filter(Boolean);
                      if (checkOverlap(value, allRanges)) {
                        return Promise.reject(
                          new Error(t("message.error.time_overlap"))
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                style={{ marginBottom: "auto" }}
              >
                <TimePicker.RangePicker
                  use12Hours
                  format="hh:mm A"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Flex justify="start" gap="small">
                {fields.length === 1 ? (
                  <Button
                    type="primary"
                    shape="circle"
                    onClick={() => add()}
                    icon={<PlusOutlined />}
                  />
                ) : index + 1 === fields.length ? (
                  <>
                    <Button
                      onClick={() => remove(name)}
                      type="primary"
                      shape="circle"
                      icon={<MinusOutlined />}
                    />
                    <Button
                      type="primary"
                      shape="circle"
                      onClick={() => add()}
                      icon={<PlusOutlined />}
                    />
                  </>
                ) : null}
              </Flex>
            </Col>
          </Row>
        ))
      }
    </Form.List>
  );
}

export default DayField;
